// extracted by mini-css-extract-plugin
export default {"textarea":"Robots_textarea__+IybU","textareaContainer":"Robots_textareaContainer__adIVa"};